// SessionProvider reads Telegram.initData on mount, so bootstrap awaits this SDK.
export const loadTelegramWebApp = (scriptUrl: string): Promise<void> => {
  if (!scriptUrl || window.Telegram?.WebApp) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = scriptUrl;
    script.async = true;

    const finish = () => {
      window.clearTimeout(timeout);
      script.onload = null;
      script.onerror = null;
      resolve();
    };

    const fail = () => {
      console.warn("Telegram WebApp SDK could not be loaded.");
      script.remove();
      finish();
    };

    // An unavailable CDN must not prevent the regular website from starting.
    const timeout = window.setTimeout(fail, 10000);
    script.onload = finish;
    script.onerror = fail;
    document.head.appendChild(script);
  });
};
